import React from 'react';
import { AlertTriangle, Clock, Calendar } from 'lucide-react';

// Standardized urgency display component
// Use this component anywhere urgency guidance needs to be shown

const UrgencyGuidance = ({ emergency, urgent, routine, compact = false }) => {
  if (!emergency && !urgent && !routine) return null;

  if (compact) {
    return (
      <div className="urgency-guidance-compact">
        {emergency && (
          <p className="urgency-emergency-compact">
            <AlertTriangle size={14} />
            <strong>Emergency:</strong> {emergency}
          </p>
        )}
        {urgent && (
          <p className="urgency-urgent-compact">
            <Clock size={14} />
            <strong>24–72 hrs:</strong> {urgent}
          </p>
        )}
        {routine && (
          <p className="urgency-routine-compact">
            <Calendar size={14} />
            <strong>Routine:</strong> {routine}
          </p>
        )}
      </div>
    );
  }

  return (
    <div className="urgency-guidance" data-testid="urgency-guidance">
      {emergency && (
        <div className="urgency-card urgency-emergency" data-testid="urgency-emergency">
          <div className="urgency-header">
            <AlertTriangle size={18} />
            <span className="urgency-label">Seek Emergency Care Immediately</span>
          </div>
          <p className="urgency-description">{emergency}</p>
        </div>
      )}
      
      {urgent && (
        <div className="urgency-card urgency-urgent" data-testid="urgency-urgent">
          <div className="urgency-header">
            <Clock size={18} />
            <span className="urgency-label">Contact a Urologist Promptly (Within 24–72 Hours)</span>
          </div>
          <p className="urgency-description">{urgent}</p>
        </div>
      )}
      
      {routine && (
        <div className="urgency-card urgency-routine" data-testid="urgency-routine">
          <div className="urgency-header">
            <Calendar size={18} />
            <span className="urgency-label">Routine Follow-Up Recommended</span>
          </div>
          <p className="urgency-description">{routine}</p>
        </div>
      )}
    </div>
  );
};

export default UrgencyGuidance;
